export default {
  new: {
    head: 'New Binnacle version',
    message: 'A new version is available for download now. Please install it from your app market'
  },
  security: {
    passwordChange: 'You must change your password',
    goToProfile: 'Go to Profile'
  },
  updateAvailable: 'Update available',
  update: 'Update',
  storeUnavailable: 'The app store could not be opened on this device'
}
